<template>
  <div
    class="drop-zone"
    :class="{ 'drop-zone--dragover': dragover, 'is-loading': loading }"
  >
    <template v-if="!loading">
      <input
        :id="name"
        :disabled="loading"
        ref="fileInput"
        class="drop-zone__input"
        :name="name"
        accept="image/jpeg, image/jpg, image/pjpg, image/png, image/gif, image/mpo"
        multiple
        type="file"
        @change="onFileChanged"
        @dragend="onDragLeave"
        @dragleave="onDragLeave"
        @dragover="onDragOver"
      />
      <div class="drop-zone__label">
        <span class="icon is-large">
          <i class="fa fa-cloud-upload"></i>
        </span>
        <h5 class="text-medium mt-2">
          {{ $t("images.upload.dropZone.upload.headline") }}
        </h5>
        <div class="d-inline-flex align-items-center mx-auto mt-3">
          <span class="mr-3">{{
            $t("images.upload.dropZone.upload.subline")
          }}</span>
          <button class="button is-primary">
            {{ $t("images.upload.dropZone.upload.button") }}
          </button>
        </div>
        <slot></slot>
      </div>
    </template>
  </div>
</template>

<script>
export default {
    name: 'drop-zone',

    props: {
        name: {
            type: String,
            required: true,
        },

        loading: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    data() {
        return {
            dragAndDropCapable: true,
            dragover: false,
        };
    },

    mounted() {
        this.dragAndDropCapable = this.isAdvancedUpload();
    },

    methods: {
        isAdvancedUpload() {
            if(this.$refs.fileInput) {
                const ref = this.$refs.fileInput;
                return (
                    ('draggable' in ref || ('ondragstart' in ref && 'ondrop' in ref)) &&
                    'FormData' in window &&
                    'FileReader' in window
                );
            }
        },

        onFileChanged() {
            const inputFiles = this.$refs.fileInput && this.$refs.fileInput.files;
            this.$emit('change', inputFiles);
            this.$refs.fileInput.value = '';
            this.dragover = false;
        },

        onDragOver() {
            this.dragover = true;
        },

        onDragLeave() {
            this.dragover = false;
        },
    },
};
</script>

<style lang="scss">
@import "drop-zone.scss";
</style>



// WEBPACK FOOTER //
// src/views/components/dropzone/DropZone.vue